export default "__VITE_ASSET__BpQSaRiD__"